import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/registerSW";
import { installImgRetry } from "@/lib/imgRetry";
import { installVitals } from "@/lib/vitals";

installImgRetry();
installVitals();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
